import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore'
import config from './config'

const EMAIL = 'bruno.reactdeveloper@gmail.com';
const PASSWORD = 'bruno.reactdeveloper';
const MESSAGES = 'messages';

let unsubscribe = () => {};

if (!firebase.apps.length) firebase.initializeApp(config);

export const db = firebase.firestore();
export const auth = firebase.auth();

if (typeof window !== 'undefined' && firebase.apps.length) {
   if ('measurementId' in config) firebase.analytics();
   signIn();
}


async function signIn() {
   await auth.signInWithEmailAndPassword(EMAIL, PASSWORD);
}

export async function addToDatabase(data: any, setState: Function, newState: boolean) {
   await db.collection(MESSAGES).doc(String(data.date)).set(data)
   .then(docRef => {
      setState(newState);
   })
   .catch(err => {
      console.log('ERROR has occurred');
   });
}

export async function getDatabase() : Promise<{}[]> {
   let messages : {}[] = []
   await db.collection(MESSAGES).get().then(snapshot => {
      snapshot.forEach(doc => {
         messages.push(doc.data());
      })
   })
   return messages;
}

export function onDbChange(setState: Function) : void {
   unsubscribe = db.collection(MESSAGES).onSnapshot(snapshot => {
      let messages = snapshot.docs.map(doc => doc.data());
      messages = messages.map(msg => msg);
      messages.sort((a, b) => b.date - a.date)
      setState(messages);
   })
}

export function detachListener() {
   unsubscribe();
}

export function updateMessage(msg: any, newStatus: string) {
   db.collection(MESSAGES).doc(String(msg.date)).set({
      ...msg,
      status: newStatus
   });
}

export function watchAuthStatus(func: Function) {
   console.log(process.env.REACT_APP_KAY_UID)
   auth.onAuthStateChanged(user => {
      if (user && user.uid === 'T36TEMWltkdgZ9TEAP6EovpmnKt2') {
         func(true)
         console.log(true)
      }
      else {
         func(false)
         console.log(false)
      };
   })
}

export function adminSignIn(email: string, password: string, errorFunction: Function) {
   auth.signInWithEmailAndPassword(email, password).then(res => {

   }).catch(err => {
      errorFunction(err);
   });
}

export function adminSignOut() {
   auth.signOut();
}

export default firebase;

